import React from 'react';

import { MarginOrderDirection, MarginOrderType, ProtectionOrderVariant } from '@swyftx/margin/build/types';

import { MarginProtectionOrderInput } from '@routes/SwyftxMargin/components/General';

import { useMarginTradePanelProtectionOrder } from './useMarginTradePanelProtectionOrder';

type Props = {
  tradeSide: MarginOrderDirection;
  tradeType: MarginOrderType;
  protectionOrderType: ProtectionOrderVariant;
  placeholder?: string;
  disabled?: boolean;
};

const MarginTradePanelProtectionOrder: React.FC<Props> = ({
  tradeSide,
  tradeType,
  protectionOrderType,
  placeholder,
  disabled = false,
}) => {
  const { formattedAmount, onChangeValue, onUpdateChecked, onChangeTab, tabs, checked, title, leadingLabel, error } =
    useMarginTradePanelProtectionOrder({
      tradeSide,
      tradeType,
      protectionOrderType,
    });

  return (
    <MarginProtectionOrderInput
      title={title}
      leadingLabel={leadingLabel}
      onCheckedChange={onUpdateChecked}
      value={formattedAmount}
      onChangeValue={onChangeValue}
      checked={checked}
      tabs={tabs}
      onChangeTab={onChangeTab}
      disabled={disabled}
      error={error}
      placeholder={placeholder}
      tradeSide={tradeSide}
      protectionOrderType={protectionOrderType}
    />
  );
};

export { MarginTradePanelProtectionOrder };
